export default {
  title: 'Keyword',

  one: 'Keyword',
  many: 'Keyword',

  titles: {
    create: 'Create keyword',
    matches: 'Search for matches'
  },

  labels: {
    title: 'Title',
    value: 'Value',
    text: 'Text',
    coincidences: 'List of matches:',
    create: 'Create keyword',
    remove: 'Confirm remove',
    update: 'Edit Keyword'
  },

  dialogs: {
    new: 'New keyword'
  },

  hints: {
    notFound: 'Keyword not found'
  },

  contents: {
    confirm: {
      remove: 'Confirm remove {title}?'
    }
  },

  tooltips: {
    isActive: 'Activate or deactivate a keyword list.',
    favorites: 'Make the keyword list a favorite'
  },

  snackbars: {
    created: 'Keyword successfully created.',
    updated: 'Keyword successfully updated.',
    removed: 'Keyword successfully removed.'
  }
}
